import { render, staticRenderFns } from "./CopyItem.vue?vue&type=template&id=3a24872f&scoped=true"
import script from "./CopyItem.vue?vue&type=script&lang=js"
export * from "./CopyItem.vue?vue&type=script&lang=js"
import style0 from "./CopyItem.vue?vue&type=style&index=0&id=3a24872f&prod&scoped=true&lang=css"
import style1 from "./CopyItem.vue?vue&type=style&index=1&id=3a24872f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a24872f",
  null
  
)

export default component.exports